export default {
  namespaced: true,
  state: {
    currentMatch: undefined,
    currentCompetition: undefined,
    currentRound: undefined,
  },
  mutations: {
    CURRENT_MATCH(state, update) {
      state.currentMatch = update;
    },
    CURRENT_COMPETITION(state, update) {
      state.currentCompetition = update;
    },
    CURRENT_ROUND(state, update) {
      state.currentRound = update;
    },
  },
};
